import React from 'react';
import { Box, Button, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

interface CredentialsActionsProps {
  hasChanges: boolean;
  isLoading?: boolean;
  onAdd: () => void;
  onSave: () => void;
  noMoreAvailableEnvs?: boolean;
}

export const CredentialsActions: React.FC<CredentialsActionsProps> = ({
  hasChanges,
  isLoading = false,
  onAdd,
  onSave,
  noMoreAvailableEnvs = false,
}) => {
  const AddCredentialsButton = (
    <Button
      startIcon={<AddIcon />}
      variant="outlined"
      color="primary"
      onClick={onAdd}
      disabled={noMoreAvailableEnvs}
    >
      Add Client Credentials
    </Button>
  );

  return (
    <Box
      display="flex"
      style={{ gap: 16, marginTop: 24 }}
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" style={{ gap: 12 }}>
        {noMoreAvailableEnvs ? (
          <Tooltip
            title="All the possible client credentials had already been added"
            placement="right"
          >
            <span>{AddCredentialsButton}</span>
          </Tooltip>
        ) : (
          AddCredentialsButton
        )}
      </Box>
      {hasChanges && (
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save all'}
        </Button>
      )}
    </Box>
  );
};
